import React from 'react'
import { func, object } from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { PageLoading } from '../../Loading'
import { Form } from '../../Form'
import { DuplicateEmail } from './DuplicateEmail'
import { FormFields } from './FormFields'

import { useAuthenticationState } from '../../../contexts/AuthenticationContext'

export const CompleteProfileFlow = ({ onExit, onComplete, errors }) => {
  const { user } = useAuthenticationState()

  const onSubmit = (values) => {
    onComplete(values)
  }

  if (!user) return <PageLoading />

  return (
    <>
      <FormattedMessage
        id='Authentication.CompleteProfileFlow.Message'
        defaultMessage='In order to continue using this website, you must complete your user profile, by filling in the missing information.'
        description='The text describing why the user must complete their profile.'
      >
        {(formattedText) => <p>{formattedText}</p>}
      </FormattedMessage>
      <DuplicateEmail errors={errors} onExit={onExit} />
      <Form
        initialValues={{
          email: user.email || '',
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          username: user.username || '',
        }}
        onSubmit={onSubmit}
      >
        <FormFields onExit={onExit} errors={errors} />
      </Form>
    </>
  )
}

CompleteProfileFlow.propTypes = {
  onComplete: func,
  onExit: func,
  errors: object,
}
